






























import {
  saveExpenseCategory,
  ExpenseCategory
} from "@/api/cost/expense-categories-api";
import { Component, Vue } from "vue-property-decorator";

@Component({ components: {} })
export default class ExpenseCategoryCreatePage extends Vue {
  // 確認:? 個別に書かないでいい方法がないか
  newCategory: ExpenseCategory = {
    id: "",
    name: "",
    important: true
  };

  error: string = "";

  goListPage() {
    this.$router.push({ path: "/admin/expense-categories" });
  }

  async save() {
    try {
      await saveExpenseCategory(this.newCategory);
      this.goListPage();
    } catch (error) {
      this.error = error[0];
    }
  }
}
